"use client";

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '@/store/userSlice';
import { AppDispatch } from '@/store';
import classes from './UserBar.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faCircleUser } from '@fortawesome/free-solid-svg-icons';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown
} from 'reactstrap';

interface UserBarProps {
  user: {
    username: string;
    email: string;
    firstName: string;
    middleName?: string;
    lastName?: string;
  };
}

const UserBar: React.FC<UserBarProps> = ({ user }) => {
  const dispatch = useDispatch<AppDispatch>();
  const router = useRouter();

  const unreadTickets = useSelector((state: any) => state.commCenter?.counts?.unreadTickets ?? 0);

  // const handleLogout = async () => {
  //   try {
  //     await dispatch(logout()).unwrap();
  //   } catch (error) {
  //     console.error('Logout failed:', error);
  //   }
  //   router.push('/');
  // };
  const onLogout = () => {
    const destination = window.location.hostname !== 'localhost' ? '/secure/logout' : '/logout';
    window.location.href = destination;
  };
  return (
    <div className={`${classes.userBar} !pt-[8px]`}>
      <Link href={'/secure/communication-center/inbox/notifications'}>
        <FontAwesomeIcon className='cursor-pointer text-[#ff5f0e] text-xl' icon={faEnvelope} />
      </Link>
  {unreadTickets > 0 && <span className='text-sm !-mt-[4px]'>({unreadTickets})</span>}
      <UncontrolledDropdown setActiveFromChild>
        <DropdownToggle
          caret
          className="nav-link cursor-pointer !ml-4"
          tag="a"
        >
          <FontAwesomeIcon icon={faCircleUser} className='text-xl' />
        </DropdownToggle>
        <DropdownMenu className='!bg-[#122377] !text-sm'>
          <DropdownItem
            disabled
            className='text-white !border-b !border-white'
          >
            <FontAwesomeIcon icon={faCircleUser} className='text-md !mr-2' />
            {user.firstName}  {user.middleName}  {user.lastName}
          </DropdownItem>
          <DropdownItem
            className="text-white hover:!bg-white hover:!text-[#122377]"
          >
            <Link href={"/secure/my-profile"} className='!font-light'>
              My Profile
            </Link>
          </DropdownItem>
          <DropdownItem
            className="text-white hover:!bg-white hover:!text-[#122377]"
            /*onClick={handleLogout}*/
          >
            <a href="#" onClick={onLogout} className='!font-light'>
            Logout
            </a>
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
};

export default UserBar;
